require('./view-tabs.component.scss');

class ViewTabsController {
  constructor(
    $scope,
    CurrentFilterService,
    PermissionService,
    LayoutService,
    RouterService,
  ) {
    this.$scope = $scope;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.layout = LayoutService;
    this.router = RouterService;
  }

  get filter() {
    return this.CurrentFilterService.filter;
  }
}

export const ViewTabsComponent = {
  template: require('./view-tabs.component.html'),
  bindings: {},
  controller: ViewTabsController,
};



// WEBPACK FOOTER //
// ./src/view/view-tabs.component.js